import "notyf/notyf.min.css";
import m from "mithril";
import {Notyf} from "notyf";

const notyf = new Notyf();
let serviceWorkerInstance = null;
let PostMessageHooks = {};
const callbacks = {};

window.addEventListener("message", receiveMessage, false);
let unreadnotifications = 0;

function receiveMessage(event) {
	try {
		var data = JSON.parse(event.data);
		if (data && data.id) {
			pf.CheckForMessageHooks(data.id, data.data);
		}
	} catch {}
}

var pf = {
	Unique: (arr) => {
		return [...new Set(arr)];
	},
	Wait: async (duration = 5000) => {
		await new Promise(function (resolve) {
			setTimeout(function () {
				resolve();
			}, duration);
		});
	},
	IsNumber: (num) =>
		typeof num !== "object" &&
		!Number.isNaN(+String((String(num) || "").replace(/[^0-9\.\-e]/, "") !== String(num) || num === "" ? NaN : num)),
	RemoveSpecialCharacters: (s, leaveExtension) => {
		if (leaveExtension) return s.replace(/(?:\.(?![^.]+$)|[^\w.])+/g, "_").replace(/_{2,}/g, "_");
		else return s.replace(/[^a-zA-Z0-9]/g, "_").replace(/_{2,}/g, "_");
	},
	MakeReabable: (s) => {
		return s
			.replace(/(?:\.(?![^.]+$)|[^\w.])+/g, "_")
			.replace(/_{2,}/g, "_")
			.replace("_", " ");
	},
	unreadnotifications: (offset) => {
		if (offset) {
			unreadnotifications += offset;
			// console.log({unreadnotifications});
		} else {
			return unreadnotifications;
		}
	},
	AwaitFunctions: () => {
		return {
			WaitForCallback: async (id) => {
				return new Promise(function (resolve) {
					callbacks[id] = resolve;
				});
			},
			ContinueFucntion: async (id, data) => {
				const resolve = callbacks[id];
				callbacks.delete(id);
				if (resolve) resolve(data);
			},
		};
	},
	Debounce: (func, wait = 100) => {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				func.apply(this, args);
			}, wait);
		};
	},

	ConvertToCommaSeparaterNumber: (tempText, customclass) => {
		if (customclass && customclass.split(" ").includes("Right"))
			if (!isNaN(tempText)) {
				tempText = new Intl.NumberFormat("en-IN").format(tempText);
			}
		return tempText;
	},
	GenerateUniqueID: () => {
		return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
	},
	PostMessage: (id, data) => {},
	SetUpMessageHook: (id, func) => {
		if (!PostMessageHooks[id]) {
			PostMessageHooks[id] = [];
		}
		PostMessageHooks[id].push(func);
	},
	CheckForMessageHooks: (id, data) => {
		if (PostMessageHooks[id]) {
			PostMessageHooks[id].forEach((func) => func(data));
		}
	},
	// RequestNotificationPermission: async () => {
	// 	const permission = await Notification.requestPermission();
	// 	if (permission !== "granted") {
	// 		throw new Error("Permission not granted for Notification");
	// 	} else {
	// 		navigator.serviceWorker.ready
	// 			.then(function (registration) {
	// 				return registration.pushManager.getSubscription().then(async function (subscription) {
	// 					if (subscription) {
	// 						// console.log("no need to resubscribe");
	// 						return subscription;
	// 					}

	// 					const response = await pf.APIAction("GetPushVapPbK");
	// 					const vapidPublicKey = await response.PK;
	// 					const convertedVapidKey = urlB64ToUint8Array(vapidPublicKey);

	// 					return registration.pushManager.subscribe({
	// 						userVisibleOnly: true,
	// 						applicationServerKey: convertedVapidKey,
	// 					});
	// 				});
	// 			})
	// 			.then(function (subscription) {
	// 				pf.APIAction("PushSubscribe", {
	// 					subscription: subscription,
	// 				});
	// 			});
	// 	}
	// },
	SW: (sw) => {
		if (sw) serviceWorkerInstance = sw;
		else return serviceWorkerInstance;
	},
	Inform: (message, error) => {
		if (error) {
			notyf.error(message);
		} else {
			notyf.success(message);
		}
	},
	HasNotificationPermission: () => {
		if ("Notification" in window) {
			return Notification.permission === "granted";
		}
		return false;
	},
	CreateTableElementAndCopy: (data) => {
		let el = document.createElement("div");

		let tbl = document.createElement("table");
		tbl.className = ".no-table";

		if (data.length > 0) {
			let headEl = document.createElement("thead");
			let bodyEl = document.createElement("tbody");

			data.forEach((r, i) => {
				if (i == 0) {
					let headerRow = document.createElement("tr");
					r.forEach((c) => {
						let cell = document.createElement("th");
						cell.innerHTML = c;
						headerRow.appendChild(cell);
					});
					headEl.appendChild(headerRow);
				} else {
					let headerRow = document.createElement("tr");
					r.forEach((c) => {
						let cell = document.createElement("td");
						cell.innerHTML = c;
						headerRow.appendChild(cell);
					});
					bodyEl.appendChild(headerRow);
				}
			});

			tbl.appendChild(headEl);
			tbl.appendChild(bodyEl);
			el.appendChild(tbl);
		} else alert("Sorry. There is no data");

		// data.forEach(r => {
		// 	let row = document.createElement('tr');
		// 	let cellTag = 'td';
		// 	let bodyTag = "tbody";

		// 	if (!headerCreated) {
		// 		cellTag = 'th';
		// 		bodyTag = "thead";
		// 		headerCreated = true;
		// 	}

		// 	r.forEach(c => {
		// 		let cell = document.createElement(cellTag);
		// 		cell.innerHTML = c;
		// 		row.appendChild(cell);
		// 	});

		// 	let bodyEl = document.createElement(bodyTag);
		// 	tbl.appendChild(bodyEl);

		// 	bodyEl.appendChild(row);
		// });

		el.appendChild(tbl);

		tbl.setAttribute("bgcolor", "red");
		el.style = {
			position: "absolute",
			left: "-9999px",
		};
		document.body.appendChild(el);

		if (document.createRange && window.getSelection) {
			let range = document.createRange();
			let sel = window.getSelection();
			sel.removeAllRanges();
			try {
				range.selectNodeContents(el);
				sel.addRange(range);
			} catch (e) {
				range.selectNode(el);
				sel.addRange(range);
			}

			document.execCommand("copy");
		} else if (document.body.createTextRange) {
			let range = document.body.createTextRange();
			range.moveToElementText(el);
			range.select();
			range.execCommand("Copy");
		}

		document.body.removeChild(el);
	},

	APIAction: async (apiname, data, config, body) => {
		// eslint-disable-next-line no-undef
		let result = await GetData(apiname, data, config, body);
		return result;
	},
	APIActionStandard: async (apiname, data, config, body) => {
		// eslint-disable-next-line no-undef
		let result = await GetData(apiname, data, config, body);
		return result;
	},

	uuid: () => {
		return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, (c) =>
			(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
		);
	},
	matches: (a, b) => {
		return typeof a === "string" && typeof b === "string"
			? a.localeCompare(b, undefined, {
					sensitivity: "accent",
			  }) === 0
			: a === b;
	},
	replaceAll: (text, from, to) => {
		// console.log(text, from, to, new RegExp(from, "gi"), text.replace(new RegExp(from, "gi"), to));
		return text.replace(new RegExp(from, "gi"), to);
	},
	getIntersectArray: (arrNew, arrOld, compareFuncAB) => {
		return arrNew.filter((a) => arrOld.some((b) => compareFuncAB(a, b)));
	},
	getAdditionalArray: (arrNew, arrOld, compareFuncAB) => {
		return arrNew.filter((a) => !arrOld.some((b) => compareFuncAB(a, b)));
	},
	getMissingArray: (arrNew, arrOld, compareFuncAB) => {
		return arrOld.filter((b) => !arrNew.some((a) => compareFuncAB(a, b)));
	},
	// MergeArrays: (arrOld, arrNew, compareFuncAB) => {
	// 	let intersect = this.getIntersectArray(arrNew, arrOld, compareFuncAB);
	// 	let additional = this.getAdditionalArray(arrNew, arrOld, compareFuncAB);
	// 	additional.forEach((a) => {
	// 		intersect.push(a);
	// 	});
	// 	return intersect;
	// },
	regexContains: (value, exp) => {
		// console.log("regexcontains", {value, exp});
		if (!exp) return true;

		if (exp.includes("&&")) {
			//contains all
			let expParts = exp.split("&&");
			return expParts.reduce((previous, current) => {
				if (previous) return contains(value, current);
				else return false;
			}, true);
		}

		if (exp.includes("||")) {
			//contains any
			let expParts = exp.split("||");
			return expParts.reduce((previous, current) => {
				if (previous) return true;
				else return contains(value, current);
			}, false);
		}

		if (exp.startsWith(">=")) {
			if (isNumber(value)) {
				return Number(value) >= Number(exp.replace(">=", ""));
			}
		}

		if (exp.startsWith(">")) {
			if (isNumber(value)) {
				return Number(value) > Number(exp.replace(">", ""));
			}
		}
		if (exp.startsWith("<=")) {
			if (isNumber(value)) {
				return Number(value) <= Number(exp.replace("<=", ""));
			}
		}
		if (exp.startsWith("<")) {
			if (isNumber(value)) {
				return Number(value) < Number(exp.replace("<", ""));
			}
		}
		if (exp.startsWith("=")) {
			//exact match
			return value.trim() == exp.replace("=", "").trim();
		}

		return contains(value, exp);
	},
	FindIndex: (arr, fn) => {
		arr.forEach((e, i) => {
			if (fn(e)) return i;
		});
		return -1;
	},
	SortAlphaNum: (a, b) => {
		var aA = a.replace(reA, "");
		var bA = b.replace(reA, "");
		if (aA === bA) {
			var aN = parseInt(a.replace(reN, ""), 10);
			var bN = parseInt(b.replace(reN, ""), 10);
			return aN === bN ? 0 : aN > bN ? 1 : -1;
		} else {
			return aA > bA ? 1 : -1;
		}
	},
	NumberSort: (a, b, predicate) => {
		let x = predicate ? predicate(a) : a;
		let y = predicate ? predicate(b) : b;
		return Number(x) < Number(y) ? -1 : Number(x) > Number(y) ? 1 : 0;
	},
};

var reA = /[^a-zA-Z]/g;
var reN = /[^0-9]/g;

function contains(value, exp) {
	let re = new RegExp(escapeRegExp(exp), "i");
	let result = re.test(value);
	return result;
}

function isNumber(n) {
	//console.log(n, Number(n));
	return Number(n) == n;
}

function escapeRegExp(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export default pf;
